module.exports = __webpack_public_path__ + "static/media/ellipse_cursor.cddaf72c.cur";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/cursors/ellipse_cursor.cur
// module id = 2313
// module chunks = 0